module.exports = __webpack_public_path__ + "static/emma-marsh-f6836f225e98211071f39ff647fa84d5.jpg";